<style lang="less">
.member-address-add {
    height: 100%;
    .saveBox {
      position: fixed;
      bottom: 0;
      left: 0;
      height: 70px;
      width: 100%;
      background-color: #fff;
      padding: 15px 25px;
      box-sizing: border-box;
      .saveBtn {
        height: 100%;
        background-color: #7f7f7f;
        color: #fff;
        line-height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
      }
    }
}
</style>

<template>
    <div class="member-address-add flex col">
      <div>
        <van-field v-model="editAddress.consignee" label=" 收货人姓名:" />
        <van-field 
          v-model="editAddress.mobile"
          type="tel"
          label="手机号:"
        />
        <van-field
          readonly
          clickable
          label="所在地区:"
          :value="editAddress.region"
          placeholder=""
          right-icon="arrow-down"
          @click="showPicker = true"
        />
        <van-field v-model="editAddress.address" label=" 详细地址:" />
      </div>
      <van-popup v-model="showPicker" round position="bottom">
        <van-picker show-toolbar title="所在地区" :columns="areaList"  @confirm="onConfirm"  @cancel="showPicker = false" />
      </van-popup>
      <div class="saveBox">
        <div class="saveBtn" @click="saveBtn" :style="{background: isCan ? '#409EFF' : '#7f7f7f'}">保存收货地址</div>
      </div>
        <!-- <el-form label-width="80px" ref="editAddress" :model="editAddress"  :rules="rules">
        <div id="editAddress">
          <div class="left fl">
            <ul>
              <li>
                <span class="key fl">所在地区：</span>
                <div class="area fl" style="width: 500px;">
                  <el-form-item prop="editRegionOptions">
                    <el-cascader style="width: 440px;" size="large" :options="options" v-model="editAddress.editRegionOptions" @change="handleEditChange"></el-cascader>
                  </el-form-item>
                </div>
              </li>

              <li>
                <span class="key fl">详细地址：</span>
                <div class="area-detail fl">
                  <el-form-item prop="address">
                    <el-input style="width: 440px;" resize="none" type="textarea" :rows="3" placeholder="请输入详细地址信息，如街道、小区、门牌号等信息" v-model="editAddress.address"></el-input>
                  </el-form-item>
                </div>
              </li>

              <li style="margin-bottom: 0px;">
                <span class="key fl" style="letter-spacing: 4px;">收货人：</span>
                <div class="consign fl" >
                  <el-form-item prop="consignee">
                    <el-input style="width: 160px;" placeholder="请输入姓名" v-model="editAddress.consignee"></el-input>
                  </el-form-item>
                </div>

                <span class="key fl">手机号码：</span>
                <div class="consign fl">
                  <el-form-item prop="mobile">
                    <el-input style="width: 160px;" placeholder="请输入11手机号码" v-model="editAddress.mobile"></el-input>
                  </el-form-item>
                </div>
              </li>

            </ul>
          </div>
          
          <div class="right fl">
            <p class="submit">
              <span class="primary" @click="saveEditAddress">保存地址</span>
            </p>
          </div>
        </div>
      </el-form> -->
    </div>
</template>

<script>
import { regionData,TextToCode,CodeToText } from 'element-china-area-data'
import { mapState } from 'vuex'
import { Toast } from 'vant';

export default {
    data() {
        //验证收货人手机号
      var checkMobile = (rule, value, callback) => {
        //手机号验证11为数字
        let reg = /^1\d{10}$/;
        if (value === '') {
          callback(new Error('请输入收货人的手机号'));
        } else if (!reg.test(value)) {
          callback(new Error('请输入收货人正确的手机号!'));
        } else {
          callback();
        }
      };
        return {
        options: regionData,
        editAddress:{
          // editRegionOptions: [],
          address: '',
          consignee: '',
          mobile: '',
        },
        isEdit: false,
        // areaList: [],
        regionList: [],
        showPicker: false,
        rules: {
          addRegionOptions: { type: 'array', required: true, message: '请选择配送地区。', trigger: 'change' },
          address: this.$formHelper.requiredRuleFactory('请填写配送详细地址。'),
          consignee: this.$formHelper.requiredRuleFactory('请填写收货人。'),
          mobile: [{ validator: checkMobile, trigger: 'change' }],
        }
        }
    },
    computed: {
      ...mapState('auth', {
        memberId: state => state.currentUser.id
      }),
      areaList() {
        // return this.formartRegionData(regionData)
        return this.formartRegionData(this.regionList)
      },
      isCan() {
        return this.editAddress.consignee&&this.editAddress.address&&this.editAddress.mobile&&this.editAddress.region
      }
    },
    async mounted() {
      this.regionList = await this.$store.dispatch('address/getRegion')
      this.isEdit = this.$route.params.type === 'edit' ? true : false
      if (this.isEdit) {
        this.editAddress = Object.assign({}, JSON.parse(sessionStorage.getItem('addressInfo')))
      }
    },
    methods: {
      async saveBtn() {
        if(!this.isCan) return
        if (!/^1\d{10}$/.test(this.editAddress.mobile)) {
          Toast('请输入收货人正确的手机号!');
          return
        }
        this.editAddress.memberId = this.memberId
        let result
        if (this.isEdit) {
          this.editAddress.editRegionOptions = this.regionCode
          result = await this.$store.dispatch('address/update', this.editAddress);
        } else {
          this.editAddress.addRegionOptions = this.regionCode
          result = await this.$store.dispatch('address/create', this.editAddress)
        }
        this.$router.back()
        // this.$router.push({name:'member-member-address'})
      },
      onConfirm(value) {
        this.getAddressIds(value)
        this.editAddress.region = value.join(' ')
        this.showPicker = false;
      },
      formartRegionData(list) {
        return list.map(item => {
          item.text = item.regionName
          item.value = item.id
          if (item.children&&item.children.length) {
            this.formartRegionData(item.children)
          }
          return item
        })
      },
      getAddressIds(value) {
        // let options = []
        // options[0] = TextToCode[value[0]].code
        // options[1] = value[1] ? TextToCode[value[0]][value[1]].code : ''
        // options[2] = value[2] ? TextToCode[value[0]][value[1]][value[2]].code : ''
        this.regionCode = value
      },
    },
}
</script>